var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.upload'),"title":_vm.$t('buttons.upload'),"id":"upload-button"},on:{"click":_vm.upload}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_upload")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.upload')))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6717b28f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Upload.vue
// module id = 359
// module chunks = 0